import { useNavigate, useLocation } from "react-router-dom";
import { Shield, LayoutGrid, LogOut, FlaskConical } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { isEmbedded } from "../lib/integration";

export const AdminLayout = ({ children, title, subtitle, actions }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="min-h-screen bg-slate-100 font-admin lg:flex">
      {/* Sidebar */}
      {!isEmbedded && (
        <aside className="flex w-full flex-shrink-0 flex-col bg-slate-900 lg:h-screen lg:w-64 lg:sticky lg:top-0">
          <div className="flex items-center gap-2.5 border-b border-slate-800 px-5 py-4">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-sky-400 text-slate-900">
              <Shield className="h-5 w-5" />
            </span>
            <div>
              <p className="font-display text-sm font-bold text-white">Console RGPD</p>
              <p className="text-[11px] text-slate-400">Passerelle sécurisée</p>
            </div>
          </div>
          <nav className="flex flex-1 flex-col gap-1 p-3">
            <button
              onClick={() => navigate("/admin")}
              className={`flex items-center gap-2.5 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                location.pathname === "/admin"
                  ? "bg-slate-800 text-white"
                  : "text-slate-300 hover:bg-slate-800/60"
              }`}
              data-testid="nav-organizations"
            >
              <LayoutGrid className="h-4 w-4" /> Organisations
            </button>
            {user?.dev_tools && (
              <button
                onClick={() => navigate("/admin/dev/saas-log")}
                className={`flex items-center gap-2.5 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  location.pathname === "/admin/dev/saas-log"
                    ? "bg-slate-800 text-white"
                    : "text-slate-300 hover:bg-slate-800/60"
                }`}
                data-testid="nav-dev-saas-log"
              >
                <FlaskConical className="h-4 w-4" /> Mock SaaS (dev)
              </button>
            )}
          </nav>
          <div className="border-t border-slate-800 p-3">
            <div className="mb-2 px-2">
              <p className="truncate text-sm font-medium text-white">{user?.name}</p>
              <p className="truncate text-xs text-slate-400">
                {user?.role === "super_admin" ? "Super Admin" : "Admin client"}
              </p>
            </div>
            <button
              onClick={() => {
                logout();
                navigate("/admin/login");
              }}
              className="flex w-full items-center gap-2 rounded-md px-3 py-2 text-sm text-slate-300 hover:bg-slate-800/60"
              data-testid="logout-button"
            >
              <LogOut className="h-4 w-4" /> Déconnexion
            </button>
          </div>
        </aside>
      )}

      {/* Content */}
      <div className="flex-1">
        <header className="sticky top-0 z-10 flex flex-wrap items-center justify-between gap-3 border-b border-slate-200 bg-white/90 px-5 py-4 backdrop-blur sm:px-8">
          <div>
            <h1 className="font-display text-xl font-bold tracking-tight text-slate-900 sm:text-2xl">{title}</h1>
            {subtitle && <p className="mt-0.5 text-sm text-slate-500">{subtitle}</p>}
          </div>
          {actions}
        </header>
        <div className="p-5 sm:p-8">{children}</div>
      </div>
    </div>
  );
};
